
export default function problemReducer( state = { state : 'ok' }, action )
{
    switch( action.type )
    {
        case 'DOC_FETCH_FAILED':
        case 'DOC_LIST_FAILED':
        case 'PACKAGE_LIST_FAILED':
        case 'PACKAGE_FETCH_FAILED':
            return { state : 'error', message : action.message };

        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/lib/reducers/problem.js